import React from "react";
function Blocker(props) {
  const message = props.message ? (
    <div className="pl-15">{props.message} ...</div>
  ) : null;

  let layerClasses = "overlay-layer ";
  if (props.light) layerClasses += "overlay-layer-light ";
  if (props.solid) layerClasses += "overlay-layer-solid ";
  if (props.gradient) layerClasses += "overlay-layer-gradient ";

  const layer = props.on ? (
    <div className={layerClasses}>
      <div
        className={`spinner ${
          props.spinnerFixed ? "spinner-fixed" : ""
        } spinner-track spinner-lg spinner-primary`}
      ></div>
      {message}
    </div>
  ) : null;

  let overlayClasses = "overlay ";
  if (!props.hAuto) overlayClasses += "h-100 ";
  if (props.on) overlayClasses += "overlay-block ";
  if (props.mh) overlayClasses += "mh-blocker ";

  return (
    <div className={overlayClasses}>
      {props.children}
      {layer}
    </div>
  );
}
export default Blocker;
